import React, { useCallback } from 'react';
import LocalizedText from '@LocalizedText';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { inject } from '@app/providers/QAU.ContextProvider';

import Button from '@components/buttons/Button';
import './FitTool.scss';

const FitTool = ({ flow, aspectRatioLocked, fitDisabled }) => {
  const fitImageToLine = useCallback(
    lineType => {
      const { editor } = flow;
      const { selectedFields = [] } = editor || {};

      const fitToLineMethods = {
        bleed: 'fitImageToBleedLine',
        safe: 'fitImageToSafeLine',
      };

      const imageFitMethod = fitToLineMethods[lineType];
      editor[imageFitMethod](selectedFields, aspectRatioLocked);
    },
    [flow, aspectRatioLocked],
  );

  return (
    <div id='qau-fit-tool'>
      <div className='fit-tool-title'>
        <LocalizedText id='qau-fit-tool-text' />
      </div>
      <Button className='fit-to-safe-line' onClick={() => fitImageToLine('safe')} disabled={fitDisabled}>
        <LocalizedText id='qau-fit-to-safety-tool-text' tagName='span' />
        <span className='fit-to-safe-line-example' />
      </Button>
      <Button className='fit-to-bleed-line' onClick={() => fitImageToLine('bleed')} disabled={fitDisabled}>
        <LocalizedText id='qau-fit-to-bleed-tool-text' tagName='span' />
        <span className='fit-to-bleed-line-example' />
      </Button>
    </div>
  );
};

const mapStateToProps = ({
  customize: {
    customizeData: {
      scaleParams: { aspectRatioLocked, fitDisabled },
    },
  },
}) => ({ aspectRatioLocked, fitDisabled });

FitTool.propTypes = {
  aspectRatioLocked: PropTypes.bool.isRequired,
  fitDisabled: PropTypes.bool.isRequired,
  flow: PropTypes.object.isRequired,
};

export default inject('flow')(connect(mapStateToProps)(FitTool));
